import Input from "antd/es/input";
import React from "react";
import {store} from "@redux/store";

export const Facility_CategoryRelated = []

export const Facility_CategoryFormFields = [
    {
        title: 'key',
        name: 'id',
        order: 0,
        visible: false,
        length: 0,
        type: 'text',
    },
    {
        title: 'Name',
        name: 'name',
        order: 1,
        visible: true,
        length: "w-full",
        type: 'text',
        required: true,
        render:
            <Input
                autoComplete="off"
                list="facilitycategory-suggestions"
                allowClear
                placeholder="Enter category name"
            />,
        datalist: <datalist id="facilitycategory-suggestions">
            {store.getState().FacilityCategory?.data?.map(e => (
                <option key={e.name} value={e.name}/>
            ))
            }
        </datalist>
    },
    {
        title: 'Color',
        name: 'color',
        order: 2,
        visible: true,
        length: "w-full",
        type: 'color',
        render: <Input
            type="color"
            placeholder="Select color (e.g., #FF5733)"
            style={{ height: '40px' }}
        />
    },
    {
        title: 'Created By',
        name: 'createdby_name',
        order: 10,
        visible: true,
        length: "w-full",
        type: 'text',
        render: <Input disabled/>
    },
    {
        title: 'Created Date',
        name: 'created_date',
        order: 11,
        visible: true,
        length: "w-full",
        type: 'Date',
        render: <Input disabled/>
    },
    {
        title: 'Modified By',
        name: 'modifiedby_name',
        order: 12,
        visible: true,
        length: "w-full",
        type: 'text',
        render: <Input disabled/>
    },
    {
        title: 'Modified Date',
        name: 'modified_date',
        order: 13,
        visible: true,
        length: "w-full",
        type: 'Date',
        render: <Input disabled/>
    },
]

